import logo from './logo.svg';
import './App.css';
import Body from './components/body';
import Footer from './components/footer';

function App() {
  return (

    <div className="App">

      <div className='App-content'>
      <Body />

      </div>

      {/* <Footer/> */}

     
    </div>
  );
}

export default App;
